<app-loading-spinner id="loading-Overlay" color="white" [text]="text" [translate]="translate"
    [progressText]="progressText" *ngIf="isVisible"></app-loading-spinner>